import {Pipe, PipeTransform} from '@angular/core';
import {BroadcastNotificationTypes} from "../enum/BroadcastNotificationTypes";

@Pipe({
  name: 'broadcastNotification'
})
export class BroadcastNotificationPipe implements PipeTransform {
  public transform(typeP: BroadcastNotificationTypes): string {
    if (typeP) {
      switch (typeP) {
        case BroadcastNotificationTypes.Banner: return 'Banner';
        case BroadcastNotificationTypes.Notification: return 'Notification';
        case BroadcastNotificationTypes.TopStrip: return 'Top Strip';
      }
    }
    return 'Unknown Broadcast Notification Type';
  }
}
